import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import useRefreshToken from '../../hooks/useRefreshToken';
import useAuth from '../../hooks/useAuth';
import LoadingOverlay from '../Generic/LoadingOverlay';

const PersistLogin = () => {
    const [isLoading, setIsLoading] = useState(true);
    const refresh = useRefreshToken();
    const { auth, persist } = useAuth();

    useEffect(() => {
        let isMounted = true;

        const verifyRefreshToken = async () => {
            try {
                await refresh();
            }
            catch (err) {
                if (process.env.NODE_ENV === 'development') {
                    console.error('Refresh token error:', err);
                }
            }
            finally {
                isMounted && setIsLoading(false);
            }
        }
       
        !auth?.accessToken && persist ? verifyRefreshToken() : setIsLoading(false);

        return () => isMounted = false;
    }, [])

    useEffect(() => {
    }, [isLoading])

    return (
        <>
            {!persist
                ? <Outlet />
                : isLoading
                    ? <LoadingOverlay message="Loading data..." />
                    : <Outlet />
            }
        </>
    )
}

export default PersistLogin;